import { FilterGroup } from 'components/Filters/components/FilterModal'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { FilterStore } from 'components/Filters/FilterStore'
import { useListUserTypes } from 'services/users'

export function UserFilters({ store }: { store: FilterStore }) {
  const { data: userTypes } = useListUserTypes()

  return (
    <FilterGroup title="Filters">
      <SelectFilter
        filterKey="user_type"
        title="User Type"
        options={userTypes ?? []}
        filterStore={store}
      />
      <SelectFilter
        filterKey="is_active"
        title="Status"
        options={[
          { value: 'true', label: 'Active' },
          { value: 'false', label: 'Inactive' },
        ]}
        filterStore={store}
      />
    </FilterGroup>
  )
}
